import { createPosition } from "@shared/common/utils/create";
import shortUUID from "short-uuid";
import type { ICardWrapperNode, PartialNode } from "../type";

const createCardWrapperNode = (
  data?: PartialNode<ICardWrapperNode>
  // options?: CreateNodeOptions
): ICardWrapperNode => {
  return {
    id: shortUUID.generate(),
    pluginData: {},
    // TODO: contentMeta 추가
    // pluginData: {
    //   contentEditorPropSeq: 0,
    //   contentMeta: [
    //     {
    //       type: "cardwrapper_end_date",
    //       name: "카운트다운 종료 일시",
    //     },
    //     {
    //       type: "text_content",
    //       name: "텍스트 내용",
    //     },
    //     {
    //       type: "cardwrapper_format",
    //       name: "카운트다운 형식",
    //     },
    //   ],
    // },
    // reactions: [],
    alignHorizontal: "CENTER",
    position: createPosition(data?.position),
    layout: {
      type: "GRID",
      row: 1,
      col: 1,
      rowGap: 0,
      colGap: 0,
    },
    card: {
      type: "PPT",
      titleFontName: { style: "800", family: "PretendardVariable-v1" },
      titleFontSize: { value: 24, unit: "px" },
      descriptionFontName: { style: "400", family: "PretendardVariable-v1" },
      descriptionFontSize: { value: 16, unit: "px" },
    },

    effects: [],
    fills: [],
    visible: true,
    locked: false,
    reactions: [],

    // 노드트리 등에서 보이는 이름
    name: "카드 래퍼",

    // 인자값
    ...data,

    // 필수값
    type: "CARD_WRAPPER",
  };
};

export default createCardWrapperNode;
